export default __webpack_public_path__ + "static/media/naverBlog.84a58159.svg";